import { util } from "@/common/theme";
import BorderedIcon from "@/components/BorderedIcon";
import { setTypography } from "@/mono/lib/styles/mixins";
import SplitText from "mono/components/SplitText";
import styled from "styled-components";

export default function CTAFooter({
  title = "So... is it your time to <strong>shine</strong>?",
  cta: { href, text } = { href: "mailto:cu@nine.nl", text: "Get in touch" },
}) {
  return (
    <Wrapper>
      <div className="project-footer__inner">
        <SplitText
          animateOnScroll={true}
          tag="h3"
          dangerouslySetInnerHTML={{ __html: title }}
        >
          {title}
        </SplitText>
        <div className="project-footer__cta">
          <BorderedIcon
            dontTriggerPageTransition
            href={href}
            text={text}
          ></BorderedIcon>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${util.inner}

  display: flex;
  justify-content: center;
  align-items: center;

  .project-footer__inner {
    padding: 200rem 0rem;
  }

  h3 {
    text-align: center;
    color: ${({ theme }) => theme.theme.textColor};
    ${setTypography("heading3")}
    font-weight: 100;
    max-width: 800rem;

    strong {
      font-weight: 400;
      font-size: inherit;
      line-height: inherit;
    }
  }

  .project-footer__cta {
    margin-top: 100rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30rem;
  }
`;
